import remember from "../utils/remember.js";
import GamePiece from "./game-piece.js";

export default class GamePiecePeasant extends GamePiece {

    constructor(...args) {
        super(...args);
        this.isPeasant = true;
    }

    canAttackByDirection = direction => remember(this, `__canAttackByDirection<${direction}>`, () => {
        const {
            value,
            teamIndex,
        } = this;
        const pieceToAttack = this.getPieceToAttackByDirection(direction);

        if (!pieceToAttack) return false;
        if (pieceToAttack.isEmpty) return false;
        if (pieceToAttack.isUnturned) return false;
        if (teamIndex === pieceToAttack.teamIndex) return false;

        // peasants can only attack other peasants or the king
        return (
            (pieceToAttack.isKing)
            ||
            (value >= pieceToAttack.value)
        );
    });

}
